module.exports = __webpack_public_path__ + "img/heart_6.1c770307.png";